

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setResultModalData, showModal, showNestedModal } from "../modal/modalSlice";
import axiosInstance from "../../axios/axiosInstance";

const initialState = {

    isLoadingGetProjectNameByTaxNo: false,


    isLoadingGetAllCompanyForLoadBulk: false,
    companyListForLoadBulk: [],


    isLoadingAddLoadBulk: false,


    isLoadingAllLoadBulkResponse: false,


    projectList: []



}

//! toplu yük ekleme admin için şirket sorgusu
export const getProjectNameByTaxNo = createAsyncThunk("loadBulk/GetProjectNameByTaxNo", async(query, thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`companies/GetProjectNameByTaxNo?TaxNo=${query}`)
        
        return data
    } catch (error) {
        thunkApi.dispatch(showNestedModal("result"));
        thunkApi.dispatch(setResultModalData({ msg: error.response.data.ErrorDto.Errors[0], resultType: "error", btnText1: "Kapat"}));
        return thunkApi.rejectWithValue(error)
    }
})

//! toplu yük eklemede tüm firmaları çekmek için

export const getAllCompanyForLoadBulk = createAsyncThunk("loadBulk/getAllCompanyForLoadBulk", async(_, thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`companies/GetAllCompany`)
        
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})


export const addLoadBulk = createAsyncThunk("loadBulk/addLoadBulk", async(body, thunkApi)=> {
    try {
        
        const file = new FormData();
        file.append("file", body.file)
        file.append("publishing", body.publishing)
        if(body.companyProjectId){
            file.append("companyProjectId", body.companyProjectId)
        }
        if(body.taxNo){
            file.append("taxNo", body.taxNo)
        }
        if(body.scheduledPublishTimeHours){
            file.append("scheduledPublishTimeHours", body.scheduledPublishTimeHours)
        }
        const {data} = await axiosInstance.post(`/Load/AddLoadToplu`, file)

        
        if(data){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: data, resultType: "success", routePath: "/yukler-listesi", btnText1: "Listeyi Görüntüle"}))
        }
        else{
            thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})


//! toplu yük get
export const allLoadBulkResponse = createAsyncThunk("loadBulk/allLoadBulkResponse", async(_, thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.get(`/Load/GetAllBulkUploadResult`)
        
        return data.data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})

const loadBulkSlice = createSlice({
    name: "loadBulk",
    initialState,
    reducers: {

    },
    extraReducers:(builder)=> {
        builder

        //! getProjectNameByTaxNo
        .addCase(getProjectNameByTaxNo.pending, (state)=> {
            state.isLoadingGetProjectNameByTaxNo = true
        })
        .addCase(getProjectNameByTaxNo.fulfilled, (state, action)=> {
            state.isLoadingGetProjectNameByTaxNo = false
            state.projectList = action.payload.data.$values
        })
        .addCase(getProjectNameByTaxNo.rejected, (state, action)=> {
            state.isLoadingGetProjectNameByTaxNo = false
        })


        //! getAllCompanyForLoadBulk
        .addCase(getAllCompanyForLoadBulk.pending, (state)=> {
            state.isLoadingGetAllCompanyForLoadBulk = true
        })
        .addCase(getAllCompanyForLoadBulk.fulfilled, (state, action)=> {
            state.isLoadingGetAllCompanyForLoadBulk = false
            state.companyListForLoadBulk = action.payload.data.$values
        })
        .addCase(getAllCompanyForLoadBulk.rejected, (state, action)=> {
            state.isLoadingGetAllCompanyForLoadBulk = false
        })


        //! addLoadBulk
        .addCase(addLoadBulk.pending, (state)=> {
            state.isLoadingAddLoadBulk = true
        })
        .addCase(addLoadBulk.fulfilled, (state, action)=> {
            state.isLoadingAddLoadBulk = false
        })
        .addCase(addLoadBulk.rejected, (state, action)=> {
            state.isLoadingAddLoadBulk = false
        })


        //! allLoadBulkResponse
        .addCase(allLoadBulkResponse.pending, (state)=> {
            state.isLoadingAllLoadBulkResponse = true
        })
        .addCase(allLoadBulkResponse.fulfilled, (state, action)=> {
            state.isLoadingAllLoadBulkResponse = false
        })
        .addCase(allLoadBulkResponse.rejected, (state, action)=> {
            state.isLoadingAllLoadBulkResponse = false
        })
    }
})


export const {
    setTopluYukErrorMessage,
    setLoadItemSelect,
    setLoadItemData,
    updateLoadItem,
    getBelgeData,
    deleteSingleLoadItem,
    getBelgeDataSingleItem,
    setTeklifUserId,
    setTopPagesItemNotificationClicked,
    resetSingleShipmentLoadItem,
    setTopluYukSuccessMessage,
    setShipmentData,
    setSelectedLoadListCompany,
    updateLoadItemForPublishing,
    setSelectedAspiredLoadId
} = loadBulkSlice.actions
export default loadBulkSlice.reducer
